import { render, staticRenderFns } from "./SummaryForm.vue?vue&type=template&id=4718fcbe&scoped=true"
import script from "./SummaryForm.vue?vue&type=script&lang=ts"
export * from "./SummaryForm.vue?vue&type=script&lang=ts"
import style0 from "./SummaryForm.vue?vue&type=style&index=0&id=4718fcbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718fcbe",
  null
  
)

export default component.exports